import ContactHeader from "../../../assets/headers/Header_Contact.jpg";

// HEADER DATA (pic + text)
export const contactHeaderData = {
    picURL: ContactHeader,
    imgTitle: "Contact",
    titleFR: "Contact",
    titleEN: "Contact",
};

export const howToCome = {
    titleFR: "Comment venir ?",
    titleEN: "How to get here ?",
    subTitle1FR: "Transports en commun",
    subTitle1EN: "Public transportation",
    subTitle2FR: "En voiture",
    subTitle2EN: "By car",
    parkParaFR:
        "Vous pouvez vous parquer sur les places bleues ou blanches sur le chemin de la gravière ou au parking d'Aligro.",
    parkParaEN:
        "You can park in the blue or white spaces on the chemin de la Gravière or at the Aligro's car park.",
    AddressTitleFR: "Adresse",
    AddressTitleEN: "Address",
    Address: "8 chemin de la Gravière, 1227 Les Acacias",
    HoursTitleFR: "Heures de cours",
    HoursTitleEN: "Lesson hours",
    HoursFR: "Du lundi au vendredi, de 9h00 à 19h00",
    HoursEN: "Monday to friday, from 9A.M to 7P.M",
};
